// 日本語 — mirrors en.js key for key. ja only uses the CLDR "other" plural
// category, so plural entries only carry the _other form.
const ja = {
  // ===== shared =====
  'common.createPlan': 'プランを作成',
  'common.save': '保存',
  'common.cancel': 'キャンセル',
  'common.delete': '削除',
  'common.edit': '編集',
  'common.retry': '再試行',
  'common.activate': '有効化',
  'common.deactivate': '無効化',
  'common.enabled': '有効',
  'common.disabled': '無効',
  'common.viewTerms': '規約を見る',
  'common.untitledPlan': '無題のプラン',
  'common.savedToast': '保存しました',

  // ===== nav / chrome =====
  'nav.home': 'ホーム',
  'nav.plans': 'プラン',
  'nav.settings': '設定',

  'mismatch.title': 'デプロイ環境の不一致',
  'mismatch.body': 'このフロントエンドビルドは {apiBase} を呼び出しますが、{hostname} から配信されています(想定:{expected})。',
  'mismatch.contact': 'テクニカルサポートにお問い合わせください — これはデプロイ設定の誤りであり、アカウントの問題ではありません。',

  'install.title': 'Shopify に接続できませんでした',
  'install.body': 'バックエンドが実行中であること、およびその SHOPIFY_API_KEY が shopify.app.toml のアプリの client_id と一致していることを確認してください。',
  'install.retry': '再試行',

  'chrome.loadingBrand': 'FlexCover を読み込み中…',
  'error.title': '問題が発生しました',
  'error.reload': '再読み込み',

  'support.badge': 'サポートビュー',
  'support.shopUnknown': '(ストア不明)',
  'support.expired': 'トークンの有効期限が切れました — サポートコンソールで再生成してください',
  'support.validUntil': 'トークンの有効期限:{time} まで',
  'support.exit': '終了',

  // ===== Home =====
  'home.title': 'FlexCover: Protection Plans へようこそ 👋',
  'home.last30days': '過去30日間',
  'home.loadingChart': 'グラフを読み込み中',
  'home.loadingOverview': '概要を読み込み中',
  'home.statOrders': 'プラン付き注文',
  'home.statRevenue': 'プランの総収益',
  'home.gettingStarted': 'はじめる',
  'home.allSet': '完了しました 🎉',
  'home.completed': '{total} 件中 {done} 件完了',
  'home.step1.title': '最初のプランを作成する',
  'home.step1.desc': '保護サービスの価格、補償内容、カート内の表示を設定します。',
  'home.step2.title': 'アプリ埋め込みを有効にする',
  'home.step2.desc': 'FlexCover: Protection Plans ブロックをオンにして、カートにウィジェットを表示します。',
  'home.step2.enable': 'アプリ埋め込みを有効にする',
  'home.step2.check': 'ステータスを確認',
  'home.step3.title': '最初の保護付き注文を獲得する',
  'home.step3.desc': 'ウィジェットが公開されると、顧客はカートでプランを追加できます — 合計は上のカードに表示されます。',
  'home.appEmbed': 'アプリ埋め込み',
  'home.checkingEmbed': 'アプリ埋め込みのステータスを確認中',
  'home.embedEnabledBody': '保護ウィジェットがストアフロントで公開されています。',
  'home.embedTheme': '(テーマ:{theme})',
  'home.embedDisabledBody': '現在、アプリはストアフロントで有効になっていません。',
  'home.embedUnknown': '不明',
  'home.embedUnknownBody': 'アプリがストアに接続されると、ストアフロントのステータスを確認できます。',
  'home.embedUnknownReason': '現在、公開中のテーマを読み取れませんでした。',
  'home.enableEmbedHint': 'Shopify 管理画面で、オンラインストア → テーマ → カスタマイズ → アプリ埋め込み に移動し、FlexCover: Protection Plans をオンにしてください。',
  'home.learnMorePrefix': '詳しくは:',
  'home.learnMoreLink': '保護プランの使い方',

  // ===== Plans list =====
  'plans.title': 'プラン',
  'plans.loading': 'プランを読み込み中',
  'plans.errorTitle': 'プランを読み込めませんでした',
  'plans.empty.heading': '最初の保護プランを作成しましょう',
  'plans.empty.body': '配送保護、延長保証、返品保険、カスタム補償を提供でき、価格設定も自由です。',
  'plans.loadDemo': 'デモプランを読み込む',
  'plans.demoLoaded': 'デモプランを読み込みました',
  'plans.demoFailed': 'デモプランの読み込みに失敗しました:{message}',
  'plans.filterPlaceholder': 'プランを絞り込む',
  'plans.addFilter': 'フィルターを追加',
  'plans.statusHeading': 'ステータス',
  'plans.typeHeading': '保護タイプ',
  'plans.statusActive': '有効',
  'plans.statusInactive': '無効',
  'plans.showing_other': '{count} 件のプランを表示中',
  'plans.sortBy': '並べ替え',
  'plans.selectAll': 'すべてのプランを選択',
  'plans.selectedCount': '{count} 件を選択中',
  'plans.bulkDeleted_other': '{count} 件のプランを削除しました',
  'plans.bulkActivated_other': '{count} 件のプランを有効化しました',
  'plans.bulkDeactivated_other': '{count} 件のプランを無効化しました',
  'plans.deleteBulkFailed': '削除に失敗しました:{message}',
  'plans.updateBulkFailed': '更新に失敗しました:{message}',
  'plans.activated': 'プランを有効化しました',
  'plans.deactivated': 'プランを無効化しました',
  'plans.updateFailed': 'プランの更新に失敗しました:{message}',
  'plans.deleted': 'プランを削除しました',
  'plans.deleteFailed': 'プランの削除に失敗しました:{message}',
  'plans.actionsFor': '「{name}」の操作',
  'plans.activatePlan': '{name} を有効化',
  'plans.deactivatePlan': '{name} を無効化',
  'plans.onlineStore': 'オンラインストア',
  'plans.optional': '任意',
  'plans.automatic': '自動',
  'plans.noMatch': '検索またはフィルターに一致するプランはありません。',
  'plans.deleteTitle': '保護プランを削除しますか?',
  'plans.deleteBody': 'が直ちにストアから削除され、顧客にはこの保護オプションが表示されなくなります。',
  'plans.helpPrefix': 'ヘルプが必要ですか? ',
  'plans.helpLink': 'お問い合わせ',
  'plans.helpSuffix': 'するか、アプリのドキュメントやチュートリアルをご覧ください。',

  'sort.date': '日付 (新しい順)',
  'sort.name': '名前 (A–Z)',
  'sort.sortOrder': 'カート順',
  'sort.price': '価格 (安い順)',

  'planType.shipping_protection': '配送保護',
  'planType.warranty': '延長保証',
  'planType.return_insurance': '返品保険',
  'planType.custom': 'カスタム保護',
  'planTypeShort.shipping_protection': '配送',
  'planTypeShort.warranty': '保証',
  'planTypeShort.return_insurance': '返品',
  'planTypeShort.custom': 'カスタム',
  'priceType.fixed': '固定金額',
  'priceType.percentage': '注文金額の割合',

  // ===== Plan editor page shell =====
  'plan.pageTitle': '保護プラン',
  'plan.loading': 'プランを読み込み中',
  'plan.notFound.heading': 'プランが見つかりません',
  'plan.notFound.body': 'この保護プランは削除された可能性があります。',
  'plan.backToPlans': 'プラン一覧に戻る',
  'plan.newTitle': '新規保護プラン',
  'plan.newSubtitle': '価格とカート表示を設定して、プランを作成します',
  'plan.subtitle': '変更は保存後にストアに適用されます',
  'plan.statusTitle': 'プランステータス',
  'plan.saveFailed': 'プランの保存に失敗しました:{message}',

  // ===== Plan editor form =====
  'form.section.type': '保護タイプ',
  'form.section.basics': 'プラン基本情報',
  'form.section.pricing': '{type}の価格設定',
  'form.pricingFallback': '保護',
  'form.section.appearance': '外観',
  'form.section.fulfillment': 'フルフィルメント',

  'form.type.shipping_protection': '配送保護',
  'form.type.shipping_protection.help': '配送中の紛失・破損・盗難から顧客の注文を保護します。',
  'form.type.warranty': '延長保証',
  'form.type.warranty.help': '製造上の欠陥と通常の摩耗を一定期間補償します。',
  'form.type.return_insurance': '返品保険',
  'form.type.return_insurance.help': '期限内の返品で全額返金できるようになります。',
  'form.type.custom': 'カスタム保護',
  'form.type.custom.help': '独自の補償メッセージを使用できます。',

  'form.defaults.untitledPlan': '無題のプラン',
  'form.defaults.viewTerms': '規約を見る',
  'form.defaults.shipping_protection.displayName': '配送保護',
  'form.defaults.shipping_protection.description': '配送中の紛失・破損・盗難からご注文を保護します。',
  'form.defaults.warranty.displayName': '延長保証',
  'form.defaults.warranty.description': '2年間、製造上の欠陥と通常の摩耗を補償します。',
  'form.defaults.return_insurance.displayName': '返品保険',
  'form.defaults.return_insurance.description': '14日以内なら理由を問わず全額返金で返品できます。',
  'form.defaults.custom.displayName': '保護プラン',
  'form.defaults.custom.description': 'ご注文に補償を追加します。',

  'form.lang.select': '言語を選択',
  'form.lang.default': '{name}(デフォルト)',
  'form.translated': '(翻訳済み)',

  'form.field.planName.label': 'プラン名(内部)',
  'form.field.planName.help': '参考用です — 顧客には表示されません',
  'form.field.nameRequired': '内部名を入力してください',
  'form.field.displayName.label': '表示名',
  'form.field.displayNameRequired': '表示名を入力してください',
  'form.field.displayName.placeholder': '表示名',
  'form.field.displayName.help': 'カートとチェックアウトで顧客に表示されます',
  'form.field.displayName.helpPreset': '{lang}で閲覧している顧客に表示されます',
  'form.field.displayName.helpPresetFallback': '{lang}で閲覧している顧客に表示されます — 空欄の場合は{primary}にフォールバックします',
  'form.field.description.label': '説明',
  'form.field.description.placeholder': '説明',
  'form.field.description.help': 'プラン名の下に表示される短い顧客向け説明',
  'form.field.disabledDescription.label': '未選択時の説明',
  'form.field.disabledDescription.placeholder': '任意 — プランが未選択のときに表示されます',
  'form.field.disabledDescription.help': 'プランのチェックボックスがオフのときに表示されます(空欄の場合は上の説明にフォールバックします)',
  'form.field.footer.label': 'フッター',
  'form.field.footerText.label': 'フッターテキスト',
  'form.field.footerLink.label': 'フッターリンク',
  'form.field.footerLink.help': 'フッターテキストのリンク先',

  'form.price.type.label': '価格タイプ',
  'form.price.fixed': '金額 ($)',
  'form.price.percentage': '割合 (%)',
  'form.price.advanced': '詳細設定',
  'form.price.pctSummary': '注文金額の {pct}%。${min} から ${inc} 刻みで ${max} まで — プラン商品には {count} 個のバリアントが生成されます',
  'form.price.tiersSummary_other': 'プラン商品には {base} のバリアントが 1 個と、カート額ルール用のバリアントが {count} 個生成されます',

  'form.validation.priceRequired': '0 より大きい値を入力してください',
  'form.validation.priceMax100': '割合は 100 を超えられません',
  'form.validation.warrantyYears': '1〜5 年の期間を入力してください',
  'form.validation.returnDays': '7〜365 日の期間を入力してください',
  'form.validation.maxGreaterThanMin': '最大値は最小値より大きい必要があります',
  'form.validation.variantIdNumeric': 'バリアント ID は数値である必要があります(非表示プランバリアントの ID)',

  'form.icon.label': 'アイコン',
  'form.icon.useEmoji': '{emoji} をプランアイコンとして使用',
  'form.icon.removeCustom': 'カスタムアイコンを削除してシールドアイコンを使用',
  'form.icon.upload': 'カスタムアイコン画像をアップロード',
  'form.icon.uploadButton': 'アップロード',
  'form.icon.uploading': 'アイコンをアップロード中',
  'form.icon.uploadHelp': '独自のアイコンをアップロード — PNG・JPEG・GIF・WebP、最大 5 MB。',
  'form.icon.error.notImage': '画像ファイル(PNG、JPEG、GIF、WebP)を選択してください。',
  'form.icon.error.tooLarge': '画像は 5 MB 以下にしてください。',

  'form.fulfillment.intro': '保護商品をいつフルフィルメント済みにするかを選択します。',
  'form.fulfillment.manually': '手動でフルフィルメントする',
  'form.fulfillment.first_item': '注文の最初の商品がフルフィルメントされたときにマークする',
  'form.fulfillment.all_items': '注文の他の商品がすべてフルフィルメントされたときにマークする',
  'form.fulfillment.immediately': '注文作成後すぐにマークする',

  'form.adv.title': '詳細設定',
  'form.adv.minPrice': '最低価格',
  'form.adv.minPriceHelp': '最初のバリアントの価格 — プランが請求する最小料金',
  'form.adv.increment': '増分金額',
  'form.adv.incrementHelp': '生成されるバリアント間の価格ステップ',
  'form.adv.maxPriceLabel': '最高価格:',
  'form.adv.explanation': 'プラン商品には {buckets} 個のバリアントが生成されます:最低価格 {min} が 1 個、残りの {rest} 個は {inc} ずつ上がり、最高価格は {max} です。チェックアウト時、顧客はカート小計の {pct}% 以上で最初に該当するバリアントを支払います — 例:$100 のカートを 2% で計算すると $2.00 となるため、$3.01 のバリアントが適用されます。 ',
  'form.learnMore': '詳細',

  'form.tiers.title': 'カート額による価格設定',
  'form.tiers.minCol': 'カート最低額',
  'form.tiers.maxCol': 'カート最高額',
  'form.tiers.priceCol': '保護価格',
  'form.tiers.addTier': 'ルールを追加',
  'form.tiers.deleteTier': 'ルール {index} を削除',
  'form.tiers.explanation': '各ルールには最小値・最大値・価格が必要です(ルールは重複できます — 最初に一致したルールが適用されます)。各ルールはプラン商品に個別のバリアントとして生成されます。どのルールにも一致しないカート合計には、メイン設定の固定価格が適用されます。 ',
  'form.tiers.error.minRequired': 'カート最低額を入力してください',
  'form.tiers.error.maxRequired': 'カート最高額を入力してください',
  'form.tiers.error.priceRequired': '保護価格を入力してください',
  'form.tiers.error.pricePositive': '価格は 0 より大きい必要があります',
  'form.tiers.error.minMax': '最小値は最大値以下である必要があります',

  // ===== Save bar =====
  'savebar.unsavedChanges': '未保存の変更があります',
  'savebar.discard': '破棄',
  'savebar.saving': '保存中',

  // ===== Preview panel =====
  'preview.title': 'プレビュー',
  'preview.simulatedSubtotal': 'シミュレートされたカート小計',
  'preview.cart': 'カート',
  'preview.product': '商品',
  'preview.total': '合計',
  'preview.subtotal': '小計',
  'preview.checkout': 'チェックアウト',
  'preview.noPlans': '有効なプランがまだありません — 顧客にはこのウィジェットは表示されません。',
  'preview.autoAdded': '自動追加',
  'preview.unsaved': '未保存',

  // ===== Settings page =====
  'settings.title': '設定',
  'settings.language.title': '言語設定',
  'settings.language.help': 'FlexCover を開いたときに表示される言語です。ストアの言語には影響しません。',
  'settings.language.label': '言語',
  'settings.language.updated': '言語を更新しました',
  'settings.language.saveFailed': '言語設定の保存に失敗しました:{message}'
};

export default ja;
